"use strict";

var _classCallCheck = require("C:/Users/Eduardo_Gasca/Documents/GitHub/APdisplay/Superprops/Superprops/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("C:/Users/Eduardo_Gasca/Documents/GitHub/APdisplay/Superprops/Superprops/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bounce = void 0;

var Bounce = /*#__PURE__*/function () {
  function Bounce() {
    _classCallCheck(this, Bounce);

    this.distance = 200;
  }

  _createClass(Bounce, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.distance !== undefined) {
        this.distance = data.distance;
      }
    }
  }]);

  return Bounce;
}();

exports.Bounce = Bounce;